export const ICONS = {
    PANIC: 'PANIC',
    GAME_LIMIT: 'GAME_LIMIT',
    SELF_TEST: 'SELF_TEST'
}

export const ICON_TYPE = {
    SYMBOL: 'symbol',
    TEXT: 'text'
}

export const ICON_TYPE_CSS_SELECTOR = {
    [ICON_TYPE.SYMBOL]: 'cgp-themes-sw-resp-icon-type-symbol',
    [ICON_TYPE.TEXT]: 'cgp-themes-sw-resp-icon-type-text'
}